const ONE_MINUTE = 60 * 1000
const ONE_HOUR = 60 * ONE_MINUTE

const ONE_MINUTE_ERROR_MESSAGES = [
  'disconnected from',
  'No response received from RPC endpoint',
  'WebSocket is not connected',
]

const ONE_HOUR_ERROR_MESSAGES = ['Rate limit reached']

export const getErrorCooldownTime = (error: unknown): number | undefined => {
  if (!(error instanceof Error)) {
    return undefined
  }
  if (ONE_MINUTE_ERROR_MESSAGES.some((msg) => error.message.includes(msg))) {
    return ONE_MINUTE
  }
  if (ONE_HOUR_ERROR_MESSAGES.some((msg) => error.message.includes(msg))) {
    return ONE_HOUR
  }
  return undefined
}
